<div class="nft-transfer-modal-content">
  <div *ngIf="selectedNfts.length > 0">
    <form #transferForm="ngForm" (ngSubmit)="onSubmit()">
      <nz-row class="nft-header underline font-bold" nzGutter="[16, 16]">
        <nz-col nzSpan="5">Image</nz-col>
        <nz-col nzSpan="5">Name</nz-col>
        <nz-col nzSpan="5">Network</nz-col>
        <nz-col nzSpan="3">
          <div class="title-with-icon flex items-center">
            Transfer
            <span
              nz-tooltip
              nzTooltipTitle="Checking this box will include this NFT in the NFT transfer when processed below."
            >
              <wen-icon-info-circle
                class="text-icons-primary dark:text-icons-primary-dark"
              ></wen-icon-info-circle>
            </span>
          </div>
        </nz-col>
        <nz-col nzSpan="3">
          <div class="title-with-icon flex items-center">
            Withdraw
            <span
              nz-tooltip
              nzTooltipTitle="Checking this box will withdraw this NFT to the verified address when the NFT transfer is processed below."
            >
              <wen-icon-info-circle
                class="text-icons-primary dark:text-icons-primary-dark"
              ></wen-icon-info-circle>
            </span>
          </div>
        </nz-col>

        <nz-col nzSpan="3">Results</nz-col>
      </nz-row>
      <nz-row
        *ngFor="let nft of selectedNfts; let i = index"
        [class.disabled]="nft.disabled"
        [ngClass]="{
          'nft-row mb-2 bg-backgrounds-secondary dark:bg-backgrounds-secondary-dark lg:grow rounded-xl p-1': true,
          'transfer-success': nft.transferred === 'success',
          'transfer-failure': nft.transferred === 'failure'
        }"
        nzGutter="[16, 16]"
      >
        <nz-col nzSpan="5" nzXs="24" nzSm="12" nzMd="5">
          <img
            loading="lazy"
            *ngIf="nft?.mediaType === 'image'"
            i18n-alt
            (error)="onImgErrorWeShowPlaceHolderVideo($event)"
            alt="NFT image"
            [src]="previewImageService.getNftSize(nft?.media) || '/assets/mocks/no_banner.jpg'"
            class="object-cover w-10 h-10 rounded"
          />

          <img
            loading="lazy"
            *ngIf="nft?.mediaType === 'video'"
            il8n-alt
            alt="NFT image"
            [src]="
              previewImageService.getVideoPreview(nft?.media) ||
              '/assets/mocks/video_placeholder.jpg'
            "
            class="object-cover w-10 h-10 rounded"
          />
        </nz-col>
        <nz-col nzSpan="5" nzXs="24" nzSm="12" nzMd="5">
          <span [ngClass]="{ strikethrough: nft.disabled }">{{ nft.name }}</span>
        </nz-col>
        <nz-col nzSpan="5" nzXs="24" nzSm="12" nzMd="5">
          <span [ngClass]="{ strikethrough: nft.disabled }" class="uppercase">{{
            nft.network
          }}</span>
        </nz-col>
        <nz-col nzSpan="3" nzXs="12" nzSm="6" nzMd="3">
          <label
            nz-checkbox
            [(ngModel)]="nft.transfer"
            name="transfer-{{ i }}"
            (ngModelChange)="updateNetworkSelection(nft)"
            [nzDisabled]="!isTransferEnabled(nft) || nft.disabled"
          ></label>
        </nz-col>
        <nz-col nzSpan="3" nzXs="12" nzSm="6" nzMd="3">
          <label
            nz-checkbox
            [(ngModel)]="nft.withdraw"
            name="withdraw-{{ i }}"
            [nzDisabled]="!nft.transfer || nft.disabled"
          ></label>
        </nz-col>
        <nz-col nzSpan="3" nzXs="24" nzSm="12" nzMd="3">
          <span>{{ nft.statusMessage }}</span>
        </nz-col>
      </nz-row>
      <nz-row nzGutter="16" class="pb-2">
        <nz-col nzSpan="24">
          <div
            class="flex flex-col justify-between mt-5 space-y-4 lg:space-y-0 lg:flex-row lg:space-x-4"
          >
            <div
              class="text-xs font-medium text-foregrounds-secondary dark:text-foregrounds-secondary-dark"
              i18n
            >
              Recipient Select
            </div>
            <div class="flex space-x-4">
              <div
                class="target-access-option"
                (click)="targetAccessOption$.next(targetAccess.OPEN)"
                [ngClass]="{
                  'target-access-option__selected':
                    (targetAccessOption$ | async) === targetAccess.OPEN
                }"
                i18n
              >
                Wallet Address
              </div>
              <div
                class="target-access-option"
                (click)="targetAccessOption$.next(targetAccess.MEMBERS)"
                [ngClass]="{
                  'target-access-option__selected':
                    (targetAccessOption$ | async) === targetAccess.MEMBERS
                }"
                i18n
              >
                Specific member
              </div>
            </div>
          </div>
        </nz-col>
        <nz-col nzSpan="24" *ngIf="(targetAccessOption$ | async) === targetAccess.OPEN">
          <input
            nz-input
            class="w-full mt-2 mb-4"
            nzSize="large"
            [(ngModel)]="recipientAddress"
            name="recipientAddress"
            placeholder="Recipient Wallet Address"
            required
          />
        </nz-col>
        <nz-col nzSpan="24" *ngIf="(targetAccessOption$ | async) === targetAccess.MEMBERS">
          <nz-form-item class="mt-2">
            <nz-form-control>
              <nz-select
                class="w-full"
                nzMode="default"
                nzSize="large"
                [nzOptions]="(filteredMembers$ | async) || []"
                [nzServerSearch]="true"
                [formControl]="transferMemberControl"
                nzShowSearch
                nzAllowClear
                i18n-nzPlaceHolder
                [nzPlaceHolder]="'Select member'"
                (nzOnSearch)="searchMember($event)"
                [nzDisabled]="(targetAccessOption$ | async) === targetAccess.OPEN"
              >
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="24">
          <button
            nz-button
            nzType="default"
            class="wen-btn-link mr-2"
            (click)="handleCancel()"
            i18n
          >
            Close
          </button>

          <button
            nz-button
            nzType="default"
            class="text-red-600 hover:text-red-800 mr-2"
            (click)="clearSelection()"
          >
            Clear NFTs
          </button>

          <button
            *ngIf="auth.isLoggedIn$ | async"
            nz-button
            nzType="primary"
            [disabled]="!canSubmit()"
            nz-tooltip
            [nzTooltipTitle]="getSubmitButtonTooltip()"
            i18n
          >
            Transfer NFTs
          </button>

          <wen-connect-wallet
            class="w-3/10 m-2"
            wrapperClass="bg-backgrounds-tertiary dark:bg-backgrounds-tertiary-dark text-foregrounds-primary dark:text-foregrounds-primary-dark"
            *ngIf="(auth.isLoggedIn$ | async) !== true"
          ></wen-connect-wallet>
        </nz-col>
      </nz-row>
    </form>
  </div>
</div>
